import { Message } from 'element-ui';
import axios from 'axios';
import Push from "push.js";
import qs from 'qs'
import { addTab } from '../utils.js'
import { sendQdMsg } from '@/utils/qidian.js';
import i18n from '@/i18n'
import { lang } from '../../../vuex/getters.js';

let mt_info = '';

// (独立)获取通话变量
function get_call_param(res) {
  let call_id = res.CallId || ''; // 呼叫唯一标识ID
  let _servnum = res.ServNum || ''; // 服务号码
  let phone400 = ''; // 400号码
  let queue_id = res.QueId || ''; // 技能组ID
  let call_queid = res.QueId || ''; // 正在通话的技能组id
  let custom = res.Custom || ''; // IVR自定义变量
  let param = '&call_id=' + call_id + '&_servnum=' + _servnum + '&phone400=' + phone400 + '&queue_id=' + queue_id + '&call_queid=' + call_queid + '&custom=' + encodeURIComponent(custom);
  return param;
}

// (独立)隐藏部分号码，用*代替：从第4位开始，隐藏4位
function hidden_part_number(str, isHiddenPart) {
  if (isHiddenPart && typeof str != 'undefined' && str != null && str.length > 7) {
    return str.replace(/(.{3}).{4}(.{0,})/, '$1****$2')
  }
  return str;
}

// (完成)生产弹屏tab页签的标题
function getPopTabTitle(ac_phone, ac_callType = '') {
  let TAB_NAME_CONFIG = window.vueInstance._config.TAB_NAME_CONFIG || null

  let tabName = ac_callType == 'in' ? `${ac_phone}${i18n.t('wincall.incomingCall')}` : `${i18n.t('wincall.businessAcceptance')}${ac_phone}`;

  if (TAB_NAME_CONFIG) {
    const { enable, call_type, phone, call_time } = TAB_NAME_CONFIG
    if (enable && (call_type || phone || call_time)) {
      tabName = ''
      if (call_type) {
        switch (ac_callType) {
          case 'in':
            tabName += i18n.t('wincall.callIn');
            break;
          case 'out':
            tabName += i18n.t('wincall.callOut');
            break;

          default:
            break;
        }
      }

      if (phone) {
        tabName += ac_phone;
      }
      if (call_time) {
        tabName += '(' + new Date().toLocaleTimeString() + ')';
      }

      return tabName
    }
  }

  return tabName;
}

/**
 * (完成)生产crm弹屏地址
 * @param {*} phone
 * @param {*} common_parmas
 * @param {*} type : 1-呼入，2-呼出，3-预览式外呼
 * @returns
 */
function getPopUrl(phone, common_parmas = {}, type = 1) {
  let { LOGIN_USER: { USER_ID, USER_NUM, VCC_ID }, isEnableCrm = false, POP_ADDRESS = {} } = window.vueInstance._config || {}
  const { public_callin, public_callout, public_old_ekt, public_old_autocall } = POP_ADDRESS
  let { mt_info, ...common} = common_parmas
  let common_parmas_str = qs.stringify(common)+`&mt_info=${mt_info}`

  // 预览式外呼
  if (type == 3) {
    if (common_parmas.pro_id) {
      return `${public_old_autocall}&${common_parmas_str}`
    }

    return `${public_old_ekt}&${common_parmas_str}`
  }

  // 企业定制域名
  let vcc_add = POP_ADDRESS[VCC_ID] || ''
  if (vcc_add) {
    return `${vcc_add}&${common_parmas_str}`
  }

  // 开启新crm
  if (isEnableCrm) {
    if (type === 1 && public_callin) { //呼入
      return `${public_callin}/${phone}?user_id=${USER_ID}&user_num=${USER_NUM}&${common_parmas_str}`;
    } else {
      return `${public_callout}?user_id=${USER_ID}&user_num=${USER_NUM}&${common_parmas_str}`;
    }
  }

  // 默认旧版crm
  return `${public_old_ekt}&${common_parmas_str}`
}

/**
* 写cookies函数
**/
function set_cookie(name, value, days = 0, domain = '') {
  var Days = arguments[2];
  if (Days > 0) {
    var exp = new Date();  //new Date("December 31, 9998");
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + (domain !== '' ? ';domain=' + domain : '');
  }
  else {
    if (domain !== '') {
      document.cookie = name + "=" + escape(value) + ";domain=" + domain;
    } else {
      document.cookie = name + "=" + escape(value);
    }
  }
}


/**
* 取cookies函数
**/
function get_cookie(name) {
  var escapedName = name.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
  var arr = document.cookie.match(new RegExp("(^| )" + escapedName + "=([^;]*)(;|$)"));
  if (arr != null) return unescape(arr[2]);
  return null;
}
/**
* 删除cookie
**/
function del_cookie(name, domain = '') {
  var Days = -1; //此 cookie 将被保存 30 天
  var exp = new Date();  //new Date("December 31, 9998");
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + '0' + ";expires=" + exp.toGMTString() + (domain !== '' ? ';domain=' + domain : '');
}

/**
 * 将主叫号码存入cookie中
 */
function set_caller_cookie() {
  var cookie_caller = document.querySelector('#cti_phone_bar_container .current_call_num').innerText;
  set_cookie('est_caller', cookie_caller);
}

/**
 * 本地存储callid及phone之间的关系
 *
 * @param phone
 * @param callId
 */
function storeCallId(phone, callId) {
  const is_enable_crm = window.vueInstance._config.isEnableCrm
  let ck_domain = '.icsoc.net'
  if (is_enable_crm && phone != '' && callId != '') {
    phone = phone.replace(/^\s*(\S*(?:\s+\S+)*)\s*$/, '$1');
    // 最多只保存最近三通电话的cookie
    let lastestPhones = get_cookie('lastestPhone');
    if (lastestPhones == null || lastestPhones.length < 1) {
      set_cookie('lastestPhone', phone, 1, ck_domain);
    } else {
      let lastestPhoneArray = lastestPhones.split(',');
      if (lastestPhoneArray.indexOf(phone) == -1) {
        lastestPhoneArray.push(phone);
      }
      if (lastestPhoneArray.length > 3) {
        let del_phone = lastestPhoneArray.shift();
        clearCallId(del_phone);
      }

      lastestPhones = lastestPhoneArray.join(',');
      set_cookie('lastestPhone', lastestPhones, 1, ck_domain);
    }

    let callIds = get_cookie('phone_callids_' + phone);
    if (callIds == null || callIds.length < 1) {
      set_cookie('phone_callids_' + phone, callId, 0.1, ck_domain);
      return true;
    }
    let callIdArray = callIds.split(',');
    let res = callIdArray.indexOf(callId);
    if (res == -1) {
      callIdArray.push(callId);
      callIds = callIdArray.join(',');
      set_cookie('phone_callids_' + phone, callIds, 0.1, ck_domain);
    }
  }

  return true;
}
/**
 * 清除cookie
 *
 * @param phone
 * @param callId
 */
function clearCallId(phone) {
  let ck_domain = '.icsoc.net'
  if (phone != '') {
    phone = phone.replace(/^\s*(\S*(?:\s+\S+)*)\s*$/, '$1');
    del_cookie('phone_callids_' + phone, ck_domain);
    // del_cookie('phone_callids_' + callnum, '.icsoc.net');
  }

  return true;
}

/**
 * 根据手机号获取标题
 */
export function getPopTabTitleV25(phone, callType = 'out') {
  let title = i18n.t('wincall.businessAcceptance')
  try {
    // 号码脱敏
    let isHiddenPart = window.cti ? (window.cti.config.getState('hiddenPartNumber') || false) : false
    let title_phone = hidden_part_number(phone, isHiddenPart);
    title = getPopTabTitle(title_phone, callType)
  } catch (error) {
    console.error(error);
  }
  return title
}

export default (WINCALL_V2) => {
  let CTIPlus = window.CTIPlus;
  let cti = null
  let isLogin = false;
  let queue = 0;
  if (!WINCALL_V2.token) {
    console.log(i18n.t('wincall.tokenEmpty'));
  } else if (WINCALL_V2.webrtc && document.location.protocol == 'http:') {
    console.log(i18n.t('wincall.httpRequired'));
  } else {
    isLogin = true;
    let options = {
      token: WINCALL_V2.token,
      agentPhone: WINCALL_V2.phone,
      agNo: WINCALL_V2.agNo,
      userId: WINCALL_V2.userId,
      vccId: WINCALL_V2.vccId,
      webrtc: WINCALL_V2.webrtc,
      autoQueue: WINCALL_V2.autoQueue,
      check: WINCALL_V2.check,
      debug: WINCALL_V2.debug,
      busy: WINCALL_V2.busy,
      autoLogin: WINCALL_V2.autoLogin || false,
      hiddenPartNumber: WINCALL_V2.hiddenPartNumber,
      language: WINCALL_V2.language,
      renderHtml: {
        autoLogin: WINCALL_V2.autoLogin || false,
      }
    }

    // 企点电话条支持多页签签入
    if(location.hash.includes('qidian/phone-bar')){
      options.allowMultiPage = true;
    }

    cti = new CTIPlus(options);

    cti.init().then(()=>{
      cti.Info.getAgentBaseInfo().then((cb)=> {
        let agentInfo = cb.data || {};
        if (agentInfo.que != undefined && agentInfo.que.length) {
          queue = parseInt(agentInfo.que[0].id) || 0;
          cti._queue = queue; // 临时添加，用于外呼的时候使用
        }
      });

      // 事件监听
      try {
        cti.Event.add('all', function (cb) {
          let ektVue = window.vueInstance
          const { my: { ekt_old_page: _pop_host = "" } = {} } = ektVue._config.URL || {};
          // 配置：USER_OUT_CALL_POPUP-外呼是否弹屏开关 USER_IN_BOUND_POPUP-呼入是否弹屏开关 IS_ENABLE_STRONG_NOTICE 是否开启来电强提醒
          const { USER_OUT_CALL_POPUP, USER_IN_BOUND_POPUP, IS_ENABLE_STRONG_NOTICE, LOGIN_USER: { VCC_ID } } = ektVue._config
          // 号码脱敏
          let isHiddenPart = cti.config.getState('hiddenPartNumber') || false
          // 是否开启新版电话弹屏
          const isEnableCcWorkbench = ektVue.$store.state.otherSystemConfig && ektVue.$store.state.otherSystemConfig.isEnableCcWorkbench;
          // 消息类型
          const POST_TYPE = ektVue._config.POST_MSG_TYPE;

          try {
            const { eventName, UserData: userData = {} } = cb
            // console.log('============通话事件', eventName, cb);
            let call_param = get_call_param(cb); // 通话变量

            // 外呼：坐席侧来电
            if (eventName === 'phoneRingOutbound') {
              mt_info = cb || '';
            }

            if(location.hash.includes('qidian/phone-bar')){
              // 振铃
              if(cb.MT==3 && cb.PhoSta==5){
                const obj = {
                  type: 'ExtApp.FloatPage',
                  method: 'openTopMenu',
                  payload: null
                }
                ektVue.$store.dispatch('setQidianExpandCalling', true);
                sendQdMsg(obj)
              }
            }
            // 外呼：坐席接通后，呼叫客户侧
            if (eventName === 'phoneCallOut') {
              let _called = cb.Called;
              let un_popup = userData.un_popup || 0;
              let close_tab = userData.closeTab || 0;
              let { enableActions, eventType, ...js_mt_info } = mt_info || cb || {};
              js_mt_info = encodeURIComponent(JSON.stringify(js_mt_info));

              storeCallId(_called, cb.CallId);
              set_caller_cookie();

              const currentTab = ektVue.$store.state.tabData.find(tab => tab.key == ektVue.$store.state.activeTabKey) || {}

              /**
               * userData.closeTab
               *  场景：crm中保存客户时，如果勾选了“自动跳转并呼叫”，则会关闭当前弹屏页面
               * userData.un_popup
               *  说明：自定义是否开启弹屏
               */
              if (close_tab && currentTab.call_out_setting !== 1) {
                let currentTabKey = ektVue.$store.state.activeTabKey;
                let delObj = {
                  type: '1',
                  title: currentTabKey
                }
                window.postMessage(delObj, '*')
                // ektVue.$store.dispatch('delTab', delObj);
              }

              if (USER_OUT_CALL_POPUP == 1 && !un_popup) {
                let title_phone = hidden_part_number(_called, isHiddenPart);
                let tab_name = getPopTabTitle(title_phone, 'out')
                let popUrlParam = {
                  phone: _called,
                  call_id: cb.CallId,
                  ...userData,
                  mt_info: js_mt_info
                }
                let pop_url = getPopUrl(
                  _called,
                  popUrlParam,
                  2
                )

                if (userData._tag && userData._tag == 'autocall:pvc') {
                  let pvckey = 'wincall_event_pvc_' + cb.CallId;
                  let exp = new Date();
                  exp.setTime(exp.getTime() + 60 * 500);
                  document.cookie = pvckey + '=' + js_mt_info + '; path=/; domain=.icsoc.net; expires=' + exp.toUTCString();
                  return;
                }

                console.log('wincall-init', eventName, pop_url)

                if(isEnableCcWorkbench === 1) {
                  const params = {
                    type: POST_TYPE.NEW_CALL_POP_SCREEN,
                    eventName,
                    callData: {
                      ...popUrlParam
                    }
                  }
                  if(location.hash.includes('qidian/phone-bar')){
                    const obj = {
                      type: 'ExtApp.FloatPage',
                      method: 'sendMessage',
                      payload: params || null
                    }
                    sendQdMsg(obj)
                  }else{
                    window.postMessage(params, '*')
                  }
                } else {
                  if(!(ektVue.$store.state.activeTabKey === tab_name && currentTab.call_out_setting === 1)) {
                    addTab(tab_name, pop_url, 'icon')
                  }
                }
              }
            }

            // 呼入：phoneRingCalled-来电振铃,phoneRingQueue-技能组分配来电，phoneRingConsult-咨询来电振铃
            if (eventName === 'phoneRingCalled' || eventName === 'phoneRingQueue' || eventName === 'phoneRingConsult') {
              // 判断浏览器是否最小化或当前页签未激活，就发送浏览器消息
              console.log('查看页面是否未激活', document.visibilityState, IS_ENABLE_STRONG_NOTICE)
              if(IS_ENABLE_STRONG_NOTICE &&  document.visibilityState == 'hidden'){
                try {
                  Push.create(i18n.t('wincall.newCallNotify'))
                } catch (error) {

                }
              }
              let _called = cb.Caller;
              if (eventName === 'phoneRingConsult') {
                _called = cb.Others
              }
              let que_id = cb.QueId;
              let { enableActions, eventType, ...js_mt_info } = cb || {};
              js_mt_info = encodeURIComponent(JSON.stringify(js_mt_info));

              if (userData.CalledReal != undefined && userData.CalledReal) {
                _called = userData.CalledReal;
              }

              storeCallId(_called, cb.CallId);

              //来电弹屏
              let title_phone = hidden_part_number(_called, isHiddenPart);
              let tab_name = getPopTabTitle(title_phone, 'in')
              let popUrlParam = {
                phone: _called,
                ...userData,
                mt_info: js_mt_info,
                que_id: que_id,
                callin: 1
              }
              let pop_url = getPopUrl(
                _called,
                popUrlParam,
                1
              )

              //如果是惠金所那就走下面的流程
              if ('2000329' == VCC_ID) {
                axios({
                  method: "post",
                  url: "https://crm.hfax-fintech.com/customer/request/searchCustomer",
                  dataType: "json",
                  withCredentials: true,
                  data: { mobile: title_phone }
                }).then(data => {
                  addTab(title_phone + i18n.t('wincall.incomingCall'), data.data.url, 'menu_icon');
                }).catch(e => {
                  console.log(e);
                })
              } else if(USER_IN_BOUND_POPUP == 1){
                if(isEnableCcWorkbench === 1) {
                  const params = {
                    type: POST_TYPE.NEW_CALL_POP_SCREEN,
                    eventName,
                    callData: {
                      call_id: cb.CallId,
                      ...popUrlParam
                    }
                  }

                  if(location.hash.includes('qidian/phone-bar')){
                    const obj = {
                      type: 'ExtApp.FloatPage',
                      method: 'sendMessage',
                      payload: params || null
                    }
                    sendQdMsg(obj)
                  }else{
                    window.postMessage(params, '*')
                  }
                } else {
                  addTab(tab_name, pop_url + call_param, 'menu_icon');
                }
              }
            }

            // 自动外呼来电（预览式外呼）
            if (eventName === 'phoneRingAutoCall') {
              let _called = cb.Caller;
              let que_id = cb.QueId;

              if (userData.CalledReal != undefined && userData.CalledReal) {
                _called = userData.CalledReal;
              }
              storeCallId(_called, cb.CallId);

              //来电弹屏
              let title_phone = hidden_part_number(_called, isHiddenPart);;
              let tab_name = getPopTabTitle(title_phone, 'in')

              let _pro_id = cb.AcPro;
              let _task_id = cb.AcTask;
              let _user_data = cb.UserData || {};
              let _tag = _user_data._tag;
              let { enableActions, eventType, ...js_mt_info } = cb || {};
              js_mt_info = encodeURIComponent(JSON.stringify(js_mt_info));

              if (typeof _pro_id != 'undefined' && typeof _task_id != 'undefined' && typeof _tag == 'undefined') {
                let popUrlParam = {
                  callin: 1,
                  phone: _called,
                  que_id: que_id,
                  pro_id: _pro_id,
                  task_id: _task_id,
                  call_id: cb.CallId,
                  mt_info: js_mt_info,
                }
                let pop_url = getPopUrl(
                  _called,
                  popUrlParam,
                  3
                )
                console.log('wincall-init', eventName, pop_url, "_pro_id")
                if(isEnableCcWorkbench === 1) {
                  const params = {
                    type: POST_TYPE.NEW_CALL_POP_SCREEN,
                    eventName,
                    callData: {
                      ...popUrlParam
                    }
                  }

                  if(location.hash.includes('qidian/phone-bar')){
                    const obj = {
                      type: 'ExtApp.FloatPage',
                      method: 'sendMessage',
                      payload: params || null
                    }
                    sendQdMsg(obj, '*')
                  }else{
                    window.postMessage(params, '*')
                  }
                } else {
                  addTab(tab_name, pop_url, 'menu_icon');
                }
              } else {
                let popUrlParam = {
                  callin: 1,
                  phone: _called,
                  que_id: que_id,
                  mt_info: js_mt_info,
                }
                let pop_url = getPopUrl(
                  _called,
                  popUrlParam,
                  3
                )
                console.log('wincall-init', eventName, pop_url + call_param)
                if(isEnableCcWorkbench === 1) {
                  const params = {
                    type: POST_TYPE.NEW_CALL_POP_SCREEN,
                    eventName,
                    callData: {
                      call_id: cb.CallId,
                      ...popUrlParam
                    }
                  }

                  if(location.hash.includes('qidian/phone-bar')){
                    const obj = {
                      type: 'ExtApp.FloatPage',
                      method: 'sendMessage',
                      payload: params || null
                    }
                    sendQdMsg(obj, '*')
                  }else{
                    window.postMessage(params, '*')
                  }
                } else {
                  addTab(tab_name, pop_url + call_param, 'menu_icon');
                }
              }
            }

            // 接通：用于 crm 在接通后再自动填上销售负责人
            if (eventName === 'phoneConnect') {
              let callId = cb.CallId;
              if(isEnableCcWorkbench === 1) {
                const params ={
                  type: POST_TYPE.NEW_CALL_POP_SCREEN,
                  eventName,
                  callData: {
                    call_id: cb.CallId
                  }
                }

                if(location.hash.includes('qidian/phone-bar')){
                  const obj = {
                    type: 'ExtApp.FloatPage',
                    method: 'sendMessage',
                    payload: params || null
                  }
                  sendQdMsg(obj, '*')
                }else{
                  window.postMessage(params, '*')
                }
              }

              let iframe = [].slice.call(document.getElementsByTagName('iframe'))
                .filter(function (ele) {
                  return ele.src.indexOf(callId) !== -1;
                });
              if(iframe.length==0){
                return false
              }
              setTimeout(function () {
                iframe[0] && iframe[0].contentWindow && iframe[0].contentWindow.postMessage('{"type": "phoneConnect", "data": {"call_id": ' + callId + '}}',
                  '*');
              }, 1000);
            }

            // 挂机
            if (eventName === 'phoneHangup') {
              if(isEnableCcWorkbench === 1) {
                const params = {
                  type: POST_TYPE.NEW_CALL_POP_SCREEN,
                  eventName,
                  callData: {
                    call_id: cb.CallId
                  }
                }

                if(location.hash.includes('qidian/phone-bar')){
                  const obj = {
                    type: 'ExtApp.FloatPage',
                    method: 'sendMessage',
                    payload: params || null
                  }
                  sendQdMsg(obj, '*')
                  ektVue.$store.dispatch('setQidianExpandCalling', false);
                }else{
                  window.postMessage(params, '*')
                }
              }

              let pvckey = 'wincall_event_pvc_' + cb.CallId;
              let pvcMt = encodeURIComponent(JSON.stringify(cb));
              let exp = new Date();
              exp.setTime(exp.getTime() + 60 * 500);
              document.cookie = pvckey + '=' + pvcMt + '; path=/; domain=.icsoc.net; expires=' + exp.toUTCString();
              console.log('pvc--------------');
            }

            const iframe_chat_window = document.getElementById('iframe_chat')
            if (iframe_chat_window && iframe_chat_window.contentWindow) {
              iframe_chat_window.contentWindow.postMessage({ type: "cti_status", data: cb }, "*")
            }
          } catch (e) {
            console.log(e);
            console.log(i18n.t('wincall.eventListenerError') + e);
            throw 'v2.5: ' + e
          }
        });
      } catch (e) {
        console.log(e)
        throw 'v2.5: ' + e
      }
    })

    window.cti = cti
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/wincall-init/wincall-v2-5-init.js